import { Box, Checkbox, Chip, FormHelperText, Grid } from "@mui/material";
import Helpers from "../../../helpers/helpers";
import Label from "../../../components/Common/Label";
import { connect } from "react-redux";
import { useEffect, useState } from "react";
import moment from "moment";
import { Icon } from "@iconify/react/dist/iconify.js";

const Review = ({ formObj, agreement, setAgreement, isDirectSeller, makeList, modelList, bodyList, licenseCategoryList, planList, advertInterestRate, salesmanList, locationList, error, taggings, transmissionList, isSingPass }) => {
    const [interestRateOptions, setInterestRateOptions] = useState([]);
    const filterModelList = formObj?.vehicle?.bike_make_id ? makeList.find((model) => model.id === formObj?.vehicle?.bike_make_id)?.models : modelList;
    const filterColorList = filterModelList?.find((item => item?.id === formObj?.vehicle?.bike_model_id))?.colours || [];

    const colorName = filterColorList?.find((color) => color.id === formObj?.vehicle?.bike_model_colour_id)?.name || formObj?.vehicle?.color;
    const currentPlan = planList?.find((plan) => plan.id === formObj?.bike_advert_plan_id);
    const currentPriceTypeData = formObj?.pricing?.price_type_data?.[formObj?.pricing?.price_type];

    useEffect(() => {
        if (!advertInterestRate?.library || !formObj?.vehicle) return;

        const licenseCategoryName = licenseCategoryList?.find((category) => category.id === formObj?.vehicle?.license_category_id)?.name || '';
        const licenseCategoryInterestRate = advertInterestRate?.library[licenseCategoryName] || null;
        const interestRateList = licenseCategoryInterestRate?.filter((item) => item.bike_advert_type === formObj?.advert_type) || [];
        setInterestRateOptions(interestRateList);
    }, [advertInterestRate])
    return (
        <Box mt={3}>
            <Grid container spacing={2}>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                    <div className="text-bold">Advert Plan</div>
                    <div>{currentPlan?.title || '-'}</div>
                </Grid>
                {!isDirectSeller && <Grid item lg={6} md={6} sm={12} xs={12}>
                    <div className="text-bold">Credit Cost</div>
                    <div>{currentPlan?.credit_amount || '-'}</div>
                </Grid>}
                <Grid item lg={6} md={6} sm={12} xs={12}>
                    <div className="text-bold">Make / Model</div>
                    <div>{formObj?.vehicle?.make || '-'} / {formObj?.vehicle?.model || '-'}</div>
                </Grid>

                <Grid item lg={6} md={6} sm={12} xs={12}>
                    <div className="text-bold">Year of Manufacture</div>
                    <div>{formObj?.vehicle?.manu_year || '-'}</div>
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                    <div className="text-bold">Type</div>
                    <div>{formObj?.advert_type === 'new' ? 'New Motorcycle' : formObj?.advert_type === 'used' ? 'Used Motorcycle' : isDirectSeller ? 'Used Motorcycle' : 'For Rent'}</div>
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                    <div className="text-bold">Primary Colour</div>
                    <div>{colorName || "-"}</div>
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                    <div className="text-bold">Body Type</div>
                    <div>
                        {
                            Array.isArray(formObj?.vehicle?.body_type) && formObj?.vehicle?.body_type.length > 0 ?
                                formObj?.vehicle.body_type?.map((item, idx) => bodyList?.find((body) => body.id === item)?.name).join(', ')
                                : formObj?.vehicle?.body_type || '-'
                        }
                    </div>
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                    <div className="text-bold">License Category</div>
                    <div>{formObj?.vehicle?.license_category_id ? licenseCategoryList.find((item) => item.id === formObj?.vehicle?.license_category_id)?.name : '-'}</div>
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                    <div className="text-bold">Transmission</div>
                    <div>{formObj?.vehicle?.transmission ? transmissionList.find(item => item.id === formObj?.vehicle?.transmission)?.name : '-'}</div>
                </Grid>
                {
                    isDirectSeller ?
                        <>
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                <div className="text-bold">Registration Date</div>
                                <div>{formObj?.vehicle?.reg_date ? moment(formObj?.vehicle?.reg_date, "YYYY-MM-DD").format('DD MMM YYYY') : '-'}</div>
                            </Grid>
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                <div className="text-bold">COE Expiry Date</div>
                                <div>{formObj?.vehicle?.coe_expiry ? moment(formObj?.vehicle?.coe_expiry, "YYYY-MM-DD").format('DD MMM YYYY') : '-'}</div>
                            </Grid>
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                <div className="text-bold">Mileage</div>
                                <div>{formObj?.vehicle?.mileage ?? '-'} km</div>
                            </Grid>
                            {isSingPass &&
                                <>
                                    <Grid item lg={formObj?.advert_type !== 'rental' ? 6 : 6} md={6} sm={12} xs={12}>
                                        <div className="text-bold">Engine Capacity</div>
                                        <div>{formObj?.vehicle?.engine_cap || '-'}</div>
                                    </Grid>
                                </>}
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                <div className="text-bold">No. of Previous Owner</div>
                                <div>{formObj?.vehicle?.number_of_previous_owners ?? formObj?.vehicle?.no_of_owner ?? '-'}</div>
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                <div className="text-bold">Selling Price</div>
                                <div>{currentPriceTypeData?.selling_price || '-'}</div>
                            </Grid>
                            {formObj?.pricing?.price_type == 3 &&
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <div className="text-bold">Promotion Price</div>
                                    <div>{currentPriceTypeData?.promotion_price || '-'}</div>
                                </Grid>
                            }
                            {/* <Grid item lg={6} md={6} sm={12} xs={12}>
                                <div className="text-bold">Advert Plan</div>
                                <div>{currentPlan?.title || '-'}</div>
                            </Grid> */}
                            {/* <Grid item lg={6} md={6} sm={12} xs={12}>
                                <div className="text-bold">Credit Cost</div>
                                <div>{formObj?.credit || '-'}</div>
                            </Grid> */}
                        </>
                        :
                        <>
                            <Grid item lg={formObj?.advert_type !== 'rental' ? 6 : 6} md={6} sm={12} xs={12}>
                                <div className="text-bold">Engine Capacity</div>
                                <div>{formObj?.vehicle?.engine_cap || '-'}</div>
                            </Grid>
                            {
                                formObj?.advert_type === 'new' ?
                                    <>
                                        <Grid item lg={6} md={6} sm={12} xs={12}>
                                            <div className="text-bold">Vehicle Source</div>
                                            <div>{formObj?.vehicle?.vehicle_source ? Helpers.vehicleSourceList.find((item) => item.value === formObj?.vehicle?.vehicle_source)?.label : '-'}</div>
                                        </Grid>
                                        {/* <Grid item lg={6} md={6} sm={12} xs={12}>
                                            <div className="text-bold">Advert Plan</div>
                                            <div>{currentPlan?.title || '-'}</div>
                                        </Grid> */}
                                        {/* <Grid item lg={6} md={6} sm={12} xs={12}>
                                            <div className="text-bold">Credit Cost</div>
                                            <div>{currentPlan?.credit_amount?.toFixed(2) || '-'}</div>
                                        </Grid> */}
                                    </>
                                    : formObj?.advert_type === 'used' ?
                                        <>
                                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                                <div className="text-bold">Registration Date</div>
                                                <div>{formObj?.vehicle?.reg_date ? moment(formObj?.vehicle?.reg_date, "YYYY-MM-DD").format('DD MMM YYYY') : '-'}</div>
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                                <div className="text-bold">COE Expiry Date</div>
                                                <div>{formObj?.vehicle?.coe_expiry ? moment(formObj?.vehicle?.coe_expiry, "YYYY-MM-DD").format('DD MMM YYYY') : '-'}</div>
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                                <div className="text-bold">Mileage</div>
                                                <div>{formObj?.vehicle?.mileage} km</div>
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                                <div className="text-bold">No. of Previous Owner</div>
                                                <div>{formObj?.vehicle?.no_of_owner}</div>
                                            </Grid>
                                        </>
                                        : <></>
                            }
                            {
                                formObj?.advert_type !== 'rental' &&
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <div className="text-bold">Price to be shown on ad listing</div>
                                    <div>{formObj?.pricing?.price_type === 1 && formObj?.advert_type !== "used" ? 'Machine Price' : formObj?.pricing?.price_type === 2 ? 'Downpayment' : formObj?.pricing?.price_type === 3 ? 'Promotion Price' : formObj?.pricing?.price_type === 4 ? 'Selling Price' : '-'}</div>
                                </Grid>
                            }
                            {
                                formObj?.advert_type === 'rental' ?
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
                                        <div className="text-bold">Rental Pricing</div>
                                        <ul style={{ padding: 5, paddingInline: 18 }}>
                                            <li>${formObj?.pricing?.daily_rate || '-'} per day</li>
                                            <li>${formObj?.pricing?.weekend_rate || '-'} for Weekend</li>
                                            <li>${formObj?.pricing?.three_day_rate || '-'} for 3 Days</li>
                                            <li>${formObj?.pricing?.weekly_rate || '-'} Weekly</li>
                                            <li>${formObj?.pricing?.monthly_rate || '-'} Monthly</li>
                                        </ul>
                                    </Grid>
                                    :
                                    <>
                                        {
                                            formObj?.pricing?.price_type === 1 ?
                                                <>
                                                    <Grid item lg={6} md={6} sm={12} xs={12}>
                                                        <div className="text-bold">Machine Price</div>
                                                        <div>${formObj?.pricing?.machine_price || '-'}</div>
                                                    </Grid>
                                                    <Grid item lg={6} md={6} sm={12} xs={12}>
                                                        <div className="text-bold">COE</div>
                                                        <div>${formObj?.pricing?.coe || '-'}</div>
                                                    </Grid>
                                                </>
                                                : formObj?.pricing?.price_type === 4 ?
                                                    <Grid item lg={6} md={6} sm={12} xs={12}>
                                                        <div className="text-bold">Selling Price</div>
                                                        <div>${formObj?.pricing?.selling_price || '-'}</div>
                                                    </Grid>
                                                    : formObj?.pricing?.price_type === 3 ?
                                                        <>
                                                            {/* <Grid item lg={6} md={6} sm={12} xs={12}>
                                                                <div className="text-bold">Machine Price</div>
                                                                <div>${formObj?.pricing?.machine_price ? formObj?.pricing?.machine_price : '-'}</div>
                                                            </Grid> */}
                                                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                                                <div className="text-bold">Promotion Price</div>
                                                                <div>${formObj?.pricing?.promotion_price ? formObj?.pricing?.promotion_price : '-'}</div>
                                                            </Grid>
                                                        </>
                                                        : <></>
                                        }
                                        <Grid item lg={6} md={6} sm={12} xs={12}>
                                            <div className="text-bold">Min. Downpayment</div>
                                            <div>${currentPriceTypeData?.min_downpayment || '-'}</div>
                                        </Grid>
                                        <Grid item lg={6} md={6} sm={12} xs={12}>
                                            <div className="text-bold">Loan Amount</div>
                                            <div>${currentPriceTypeData?.loan_amount || '-'}</div>
                                        </Grid>
                                        <Grid item lg={6} md={6} sm={12} xs={12}>
                                            <div className="text-bold">Max Loan Tenure</div>
                                            <div>{currentPriceTypeData?.max_loan_tenure || '-'} months</div>
                                        </Grid>
                                        <Grid item lg={6} md={6} sm={12} xs={12}>
                                            <div className="text-bold">Interest Rate</div>
                                            <div>{currentPriceTypeData?.interest_rate_id ? interestRateOptions.find(option => option.id === currentPriceTypeData?.interest_rate_id)?.interest_rate : '-'}%</div>
                                        </Grid>
                                        <Grid item lg={6} md={6} sm={12} xs={12}>
                                            <div className="text-bold">Term Charge</div>
                                            <div>${currentPriceTypeData?.term_charge || '-'}</div>
                                        </Grid>
                                        <Grid item lg={6} md={6} sm={12} xs={12}>
                                            <div className="text-bold">Monthly Instalment</div>
                                            <div>${currentPriceTypeData?.monthly_instalment || '-'}</div>
                                        </Grid>
                                    </>
                            }
                            {
                                formObj?.advert_type !== 'new' &&
                                <>
                                    {/* <Grid item lg={6} md={6} sm={12} xs={12}>
                                        <div className="text-bold">Advert Plan</div>
                                        <div>{currentPlan?.title || '-'}</div>
                                    </Grid> */}
                                    {/* <Grid item lg={6} md={6} sm={12} xs={12}>
                                        <div className="text-bold">Credit Cost</div>
                                        <div>{currentPlan?.credit_amount ? currentPlan?.credit_amount?.toFixed(2) : '-'}</div>
                                    </Grid> */}
                                </>
                            }
                        </>
                }
                <Grid item lg={12} md={12} sm={12} xs={12}>
                    <div className="text-bold">Listing Title</div>
                    <div>{formObj?.advertisement?.title || '-'}</div>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                    <div className="text-bold">Listing Description</div>
                    <div dangerouslySetInnerHTML={{ __html: formObj?.advertisement?.dealer_description || '-' }}></div>
                </Grid>
                {formObj?.advert_type === "new" && !isDirectSeller &&
                    <>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <div className="text-bold">Test URL</div>
                            <div>{formObj?.advertisement?.test_ride_url || '-'}</div>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <div className="text-bold">Test URL Person In Charge</div>
                            <div>{formObj?.advertisement?.test_ride_salesman_id ? salesmanList?.find((salesman) => salesman.id === formObj?.advertisement?.test_ride_salesman_id)?.name || '-' : '-'}</div>
                        </Grid>
                    </>
                }
                <Grid item lg={12} md={12} sm={12} xs={12}>
                    <div className="text-bold">Tagging</div>
                    <div>{formObj?.advertisement?.taggings?.map(tagId =>
                        taggings.find(tag => tag.id === tagId)?.name || ''
                    ).filter(name => name).join(', ') || '-'}</div>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                    {
                        isDirectSeller ?
                            <>
                                <div className="text-bold">Contact</div>
                                <div>
                                    {
                                        formObj?.contacts ?
                                            <ol style={{ padding: 5, paddingInline: 18 }}>
                                                {
                                                    formObj?.contacts?.map((item, index) => (
                                                        <li className={index + 1 < formObj.contacts?.length ? "mb-3" : ''} key={index}>{item?.name || '-'}, {item?.phone || '-'} {!isDirectSeller ? "," + item?.email || '-' : ""}</li>
                                                    ))
                                                }
                                            </ol>
                                            : '-'
                                    }
                                </div>
                            </> :
                            <>
                                <div className="text-bold">Salesman</div>
                                <div>
                                    {
                                        formObj?.salesman ?
                                            <ol style={{ padding: 5, paddingInline: 18 }}>
                                                {
                                                    formObj?.salesman?.map((item, index) => {
                                                        const name = salesmanList.find(salesman => salesman.id === item?.salesman_id)?.name || '';
                                                        // const location_name = locationList.find(location => location.id === item?.location_id)?.name || '';
                                                        return (
                                                            <li className={index + 1 < formObj.salesman?.length ? "mb-3" : ''} key={index}>
                                                                {name || '-'}, {item?.contact || '-'}, {item?.location_name || '-'}
                                                            </li>
                                                        )
                                                    })
                                                }
                                            </ol>
                                            : '-'
                                    }
                                </div>
                            </>
                    }
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                    <div className="text-bold mb-3">Photos</div>
                    <div>
                        <Grid container spacing={2}>
                            {/* {
                            formObj?.thumbnail_image && formObj?.thumbnail_image.length > 0 &&
                            formObj?.thumbnail_image.map((item, index) => (
                                <Grid item lg={3} md={4} sm={6} xs={12} key={index}>
                                    <div style={{ position: 'relative', width: 188, }}>
                                        <img src={item?.file_base64 || Helpers.noImage} style={{ height: 120, width: 188, objectFit: 'contain' }} />
                                        <div style={{ position: 'absolute', bottom: 5, right: 5 }}>
                                            <Label.CustomLabel
                                                label={'Thumbnail'}
                                                backgroundColor={'#F9F9F9'}
                                                color={'#808588'}
                                                border={'1px solid #F9F9F9'}
                                                borderRadius={'12px'}
                                            />
                                        </div>
                                    </div>
                                </Grid>
                            ))
                        } */}
                            {
                                formObj?.photos && formObj?.photos.length > 0 &&
                                formObj?.photos.map((item, index) => (
                                    <Grid item lg={3} md={4} sm={6} xs={12} key={index}>
                                        <div style={{ position: 'relative', width: 188, }}>
                                            <img src={item?.file_base64 || Helpers.noImage} style={{ height: 120, width: 188, objectFit: 'contain' }} />
                                            {item?.is_thumbnail && <div style={{ position: 'absolute', bottom: 5, right: 5 }}>
                                                <Chip label={"Thumbnail"} style={{ color: "white", border: "1px solid white", backgroundColor: "#D13536", height: "20px", marginLeft: 2, marginBottom: 2 }} />
                                            </div>}
                                        </div>
                                        {/* <img src={item?.file_base64 || Helpers.noImage} style={{ width: 188, height: 120, objectFit: 'contain' }} /> */}
                                    </Grid>
                                ))
                            }
                            {!formObj?.photos && !formObj?.thumbnail_image && <Grid item sm={12}>-</Grid>}
                        </Grid>
                    </div>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                    <div className="text-bold mb-2">Video URLs</div>
                    <div>
                        <ol type="1" style={{ padding: 5, paddingInline: 18 }}>
                            <li className="mb-3"><span className="text-bold">Youtube: </span>{formObj?.youtube_url || '-'}</li>
                            <li className="mb-3"><span className="text-bold">Facebook: </span>{formObj?.facebook_url || '-'}</li>
                            <li className="mb-3"><span className="text-bold">Instagram: </span>{formObj?.instagram_url || '-'}</li>
                            <li className="mb-3"><span className="text-bold">Tiktok: </span>{formObj?.tiktok_url || '-'}</li>
                        </ol>
                    </div>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                    <div className="text-bold mb-3">Disclaimer</div>
                    {error?.disclaimed ? <FormHelperText className='d-flex align-items-center m-0 mt-1' sx={{ color: "#BA2727" }}><Icon icon={'fluent:error-circle-24-filled'} height={14} width={14} />{error?.disclaimed || ""}</FormHelperText> : null}
                    <div className="d-flex align-items-start">
                        <Checkbox checked={agreement}
                            checkedIcon={Helpers.checkIcon()}
                            icon={<div style={{ width: 18, height: 18, borderRadius: 3, border: '2px solid #1D1B1B' }}></div>}
                            sx={{
                                '&.Mui-checked': {
                                    color: "#a0a0a0",
                                },
                                '& .MuiSvgIcon-root': {
                                    fontSize: 18,
                                },
                            }}
                            value={agreement}
                            onChange={(event) => setAgreement(!agreement)} />
                        <div style={{ marginLeft: 10, marginTop: 5 }}>
                            <div>By posting this advertisement, I confirm and agree that:</div>
                            <div className="subheader-2">
                                <ul className="px-3">
                                    <li>
                                        Legitimate Listing: This advertisement is solely for the purpose of selling the specific vehicle described in this listing. It does not
                                        promote any other products, services, or offers.
                                    </li>
                                    <li>
                                        Accuracy & Authenticity: All information provided in this listing is true, accurate, and relates directly to the actual vehicle being offered
                                        for sale.
                                    </li>
                                    <li>
                                        Image Rights: I am the rightful owner of, or have obtained full authorization to use, all images, and other media uploaded with this
                                        advertisement.
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </Grid>
            </Grid>
        </Box >
    )
}
function mapStateToProps({ General, Login }) {
    const currentStateId = Login?.verifyAdmin?.user?.data?.profile?.state_id;
    const filteredLocationList = General?.states?.find((state) => state.id === currentStateId)?.cities || [];
    const taggings = General.taggings;


    return {
        makeList: General.bike_makes,
        modelList: General.bike_models,
        bodyList: General.bike_types,
        licenseCategoryList: General.license_categories,
        planList: General.bike_advert_plans,
        advertInterestRate: General.advertInterestRate,
        salesmanList: General.dealer_salesmans,
        locationList: General?.dealer_branches || [],
        transmissionList: General?.transmissions || [],
        taggings: taggings
    };
}
export default connect(mapStateToProps)(Review);